import './App.css';
import { Routes, Route } from 'react-router-dom';
import DailyOperation from './pages/DailyOperation';
import ProductCondition from './pages/ProductCondition';
import StrengthAnalysis from './pages/StrengthAnalysis';
import Print from './pages/Print';
import Printpagecss from './pages/Printpagecss';
import PageLayout from './layout/PageLayout';
import Production from './pages/Production';
import OperationGrid from './pages/OperationGrid';
import StopGrid from './pages/StopGrid';
import { useState } from 'react';
import PaperKind from './pages/PaperKind';
import StopOperation from './pages/StopOperation';

function App() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false); // 전역 로딩 상태

  const handleDateChange = date => {
    setSelectedDate(date); // 선택된 날짜 업데이트
  };
  return (
     <>
      {loading && (
        <div  class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000]">
           <div class="text-white text-2xl font-bold">Loading...</div>
        </div>
      )}
    <Routes>
      <Route path='/daily' element={<DailyOperation />} />
      <Route path='/' element={<ProductCondition />} />
      <Route path='/month' element={<StrengthAnalysis />} />
      <Route path='/paper' element={<PaperKind />} />
      <Route path='/print' element={<Print />} />
      <Route path='/printcss' element={<Printpagecss />} />
      <Route path='/mobile/' element={<PageLayout onDateChange={handleDateChange} setLoading={setLoading} />}>
        <Route path='production' element={<Production selectedDate={selectedDate} setLoading={setLoading} />} />
        <Route path='operationgrid' element={<OperationGrid selectedDate={selectedDate} />} />
        <Route path='stopgrid' element={<StopGrid selectedDate={selectedDate} />} />
        <Route path='stopoperation' element={<StopOperation selectedDate={selectedDate} />} />
      </Route>
      </Routes>
      </>
  );
}

export default App;
